export const CATEGORIES = {
  All: "all",
  Smartphones: "smartphones",
  Laptops: "laptops",
  Skincare: "skincare",
  Fragrances: "fragrances",
  Groceries: "groceries",
}
